module.exports = EndToken

function EndToken() {
  this.lbp = 0
}
